import { ActionType } from '../../store/actionTypes';
import { Action, ActionWithPlayload } from './core';

export function isActionWithPayload<T extends ActionType>(
  action: Action<T>,
): action is ActionWithPlayload<T, any> {
  return (action as ActionWithPlayload<T, any>).payload !== undefined;
}
